import cn from "classnames";
import Link from "next/link";

import type { LayoutType } from "../../../../../utils/layout";

import styles from "./Wikipedia.module.scss";
import { Icon } from "../../../../Icon/Icon";

const WikipediaResource = ({
  url,
  label,
  title,
  source,
  text,
  layoutType,
}: {
  url: string;
  label?: string;
  title?: string;
  source: string;
  text?: string;
  layoutType?: LayoutType;
}) => {
  return (
    <Link href={url} target="_blank" className={styles.link} prefetch={false}>
      <div
        className={cn([
          styles.wikipediaContainer,
          layoutType && styles[layoutType],
        ])}
      >
        <div
          data-testid="articleLink"
          className={cn([
            styles.innerWikipediaContainer,
            layoutType && styles[layoutType],
          ])}
        >
          <div className={styles.icon}>
            <Icon variant="wikipedia" />
          </div>
          <div className={styles.contents}>
            <div className={styles.labelAndTitle}>
              <div className={styles.label}>{label}</div>
              &nbsp;
              <div className={styles.title}>{title}</div>
            </div>
            <div className={styles.source}>{source}</div>
            <div className={styles.text}>{text}</div>
          </div>
        </div>
      </div>
    </Link>
  );
};

export { WikipediaResource };
